/**
 * Here, el is the set to the contents of the dropdown, the opener is $ddOpener.
 * Custom events handled by view contents created in template, not plugin.
 * TODO: if use this remove all 'select options' -- they would no longer apply
 */

var Marionette = require('marionette'),
    DropDownBase = require('./dropDownWr.js'),
    _ = require('underscore'),
    $ = require('jquery');


module.exports = DropDownBase.extend({  //(could make factory)
    render: function() {
        DropDownBase.prototype.render.apply(this, arguments);
        this.setElement( this.getDDContent() ); //set el to the contents of the DD menu, not the opener: TODO: if id (like overflow, need to unwrap) and apply id attributes
        this.triggerMethod('afterSwapEl', this); /* provide a hook */
        this.bindUIElements(); //do after swap in case new elements are added to el (eg cold-page action dropdown menu)
        return this;
    },
    ddDefaults: function() {
        return _.extend({}, {
            isNotMenu: true, //allows click event to prop. here
            onOpen: _.bind(this.delegateEvents, this) //(must bind to view, otherview cxt is plugin) ... //TODO: needed each time?
        }, DropDownBase.prototype.ddDefaults.call(this));
    },
    // !!!! TEMP STOPGAP FOR HORRIBLE MEM LEAK ISSUE TO DEBUG
    onBeforeDestroy: function() {
        this.unbindUIElements();
        this.off();
        this.stopListening();
        this.$('*').remove();
        DropDownBase.prototype.onBeforeDestroy.apply(this, arguments);
    },
    destroy: function() {
        DropDownBase.prototype.destroy.apply(this, arguments);
        this.$el = null;
        this.el = null;
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/common/dropDown/dropDownContentView.js
 ** module id = 431
 ** module chunks = 0
 **/